<template>
  <div class="root" @keyup.enter="handleSaveClick()">
    <form ref="gasCandle" class="compressor-form">
      <custom-input
        required
        inputType="text"
        placeholder="Название"
        labelText="Название"
        v-model="model.name"
        :errorMessage="validator['name']"
        :inputValue="model.name"
        name="name"
      />

      <main-select
        class="create-form-item"
        label="Содержимое вещество"
        id="substance-select"
        v-model="model.substance"
        :options="substancesOptions"
        placeholder="Выберите вещество"
        :clearable="false"
        isRequired
        :errorMessage="validator['substance']"
        :inputId="'substance'"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Производительность, м3/ч"
        labelText="Производительность, м3/ч"
        v-model="model.q"
        :errorMessage="validator['q']"
        :inputValue="model.q"
        name="q"
      />
    </form>
    <div class="form-button-block">
      <main-button :loading="saving" class="form-button" @click="handleSaveClick()">
        <span v-if="installation && installation.id">Сохранить</span>
        <span v-else>Создать</span>
      </main-button>

      <main-button @click="onCancelClick" color="link">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import "vue-form-generator/dist/vfg.css";
import Input from "../ui/Input.vue";
import MainButton from "../ui/MainButton.vue";
import MainSelect from "../ui/MainSelect.vue";
import { scrollToErrorInput } from "../../utils/utils.js";

export default {
  components: {
    "custom-input": Input,
    MainSelect,
    MainButton,
  },
  props: {
    saving: Boolean,
    installation: Object,
    proj_id: Number,
    substances: Array,
    substance: Object,
    type: {
      validator: function (value) {
        return [34].indexOf(value) !== -1;
      },
    },
    validator: Object,
    loadSubstances: Function,
  },
  methods: {
    onCancelClick() {
      this.$bvModal.hide("addInstallation");
    },

    validate() {
      this.$emit("update:validator", {});
      const errors = {};
      let isValid = true;
      const elementNames = [
        "substance",
        ...Array.from(this.$refs.gasCandle.elements)
          .map((element) => element.name)
          .filter((item) => Boolean(item)),
      ];
      elementNames.forEach((item) => {
        if (this.model[item] !== 0 && this.model[item] !== "0" && !this.model[item]) {
          isValid = false;
          errors[item] = "Необходимо заполнить поле";
        }
      });
      scrollToErrorInput(errors, this.$refs.gasCandle);
      this.$emit("update:validator", errors);
      return isValid;
    },

    handleSaveClick() {
      if (this.validate()) {
        this.$emit("create", this.model);
      }
    },
  },
  watch: {
    type: function (val) {
      this.$set(this.model, "obj_type", val);
    },
    installation() {
      Object.assign(this.model, this.installation);
    },
    substance() {
      this.model.substance = { code: this.substance.id, label: this.substance.name };
    },
    substances() {
      this.substancesOptions = this.substances[0].subs.map((item) => {
        return { code: item.id, label: item.name };
      });
    },
    validator() {
      this.$set(this.model, "validator", this.validator);
    },
  },
  mounted() {
    this.$set(this.model, "obj_type", this.type);

    this.loadSubstances(1);
    if (this.installation.id) {
      Object.assign(this.model, this.installation);
    }
  },
  data() {
    return {
      substancesOptions: [],

      model: {
        name: "Газовая свеча",
        obj_type: 34,
        substance: null,
        P: null,
        q: 20,
        validator: {},
      },
    };
  },
};
</script>

<style scoped>
.root {
  position: relative;
  padding: 0;
}
.compressor-form {
  padding: 0 24px 32px;
}
.create-form-item {
  margin-bottom: 16px;
}
</style>
